var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWiFi6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.44629,56.04785l-.35742-1.457C38.29,55.27881,37.25,56.7417,37.25,59.98926A2.73926,2.73926,0,1,0,39.98926,57.25a2.69763,2.69763,0,0,0-.73609.11328A3.133,3.133,0,0,1,41.44629,56.04785ZM39.98926,58.75A1.23926,1.23926,0,1,1,38.75,59.98926,1.24064,1.24064,0,0,1,39.98926,58.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.52051,30.53955A42.17576,42.17576,0,0,1,40,18.75,42.17576,42.17576,0,0,1,69.47949,30.53955l1.041-1.0791A43.66483,43.66483,0,0,0,40,17.25,43.66483,43.66483,0,0,0,9.47949,29.46045Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.52148,39.46045a29.75127,29.75127,0,0,0-41.043,0l1.043,1.0791a28.24873,28.24873,0,0,1,38.957,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.52051,49.46045a15.24885,15.24885,0,0,0-21.041,0l1.041,1.0791a13.75116,13.75116,0,0,1,18.959,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWiFi6);
export default __webpack_public_path__ + "static/media/icon_wi-fi_6.a7279564b2aba32f7678dab9bf6a02da.svg";
export { ForwardRef as ReactComponent };